var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pa-4"},[(_vm.hasData)?_c('apexchart',{attrs:{"type":_vm.chartType,"options":_vm.chartOptions,"series":_vm.series,"height":_vm.chartHeight}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }